import { render, staticRenderFns } from "./Juegos.vue?vue&type=template&id=47f94a44&scoped=true&"
import script from "./Juegos.vue?vue&type=script&lang=js&"
export * from "./Juegos.vue?vue&type=script&lang=js&"
import style0 from "./Juegos.vue?vue&type=style&index=0&id=47f94a44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f94a44",
  null
  
)

export default component.exports